export enum ModuleTokens {
  Name = 'serverParkAccessBase'
}
